<template>
    <div class="product-list-item mb w-full">
        <li>
            <div class="cart-product-info">
                <div class="pos-relative mt-1" v-if="!isLateralMenu">
                    <a
                        v-if="image"
                        @click="goToEdit"
                        class="flex-child-fixed border-radius overflow-hidden"
                    >
                        <img
                            :alt="productName"
                            :data-src="`${image}?w=156&h=233&fit=crop`"
                            class="lazy lazy-fade hidden-xs-down"
                            height="233"
                            width="156"
                        />
                        <img
                            :alt="productName"
                            :data-src="`${image}?w=104&h=156&fit=crop`"
                            class="lazy lazy-fade hidden-xs-up"
                            height="157"
                            width="104"
                        />
                    </a>
                </div>
                <div v-else>
                    <a
                        v-if="image"
                        @click="goToEdit"
                        class="flex-child-fixed border-radius overflow-hidden"
                    >
                        <img
                            :alt="productName"
                            :data-src="`${image}?w=104&h=156&fit=crop`"
                            class="lazy lazy-fade"
                            height="157"
                            width="104"
                        />
                    </a>
                </div>
                <div class="d-flex flex-column pl-4" style="width: 100%">
                    <div
                        class="d -flex flex-justify-between flex-align-center mr-2"
                        :class="[!isLateralMenu ? 'mt-1' : '']"
                    >
                        <div>
                            <a @click="goToEdit" class="product-list-item-title">
                                {{ productName }}
                            </a>
                        </div>
                    </div>
                    <div>
                        <p>{{ productQuantity }} unidades</p>
                        <template
                            v-if="
                                (usedProduct.product.type || {}).url !== 'vale-presente' &&
                                (usedProduct.product.type || {}).url !== 'assinatura' &&
                                usedProduct.product.virtual_stock &&
                                usedProduct.quantity > usedProduct.in_stock
                            "
                        >
                            <span class="badge-default mt-2" v-tooltip="productionTootlip">
                                {{ $t('toOrder') }} <i class="icon-cr icon-info ml-1"></i>
                            </span>
                        </template>
                        <p v-else-if="usedProduct.quantity <= usedProduct.in_stock">
                            {{ $t('_shop._stock.inStock') }}
                        </p>
                    </div>
                </div>

                <div class="price-customizable-product hidden-xs-down">
                    <p class="product-list-item-price" style="flex-basis: 4.8rem; font-size: 14px">
                        {{ $f.formatMoney(productsTotalPrice) }}
                    </p>
                </div>
            </div>
        </li>
        <div class="hidden-xs-up">
            <div class="d-flex flex-justify-between mb-3">
                <p>
                    <u><a @click="goToEdit">Adicionar outros tamanhos</a></u>
                </p>

                <p>
                    <u><a @click="$emit('remove-customizable')">Remover</a></u>
                </p>
            </div>
        </div>
        <div class="mb-3">
            <p class="mt-2 hidden-xs-down margin-cart">
                <u><a @click="goToEdit">Adicionar outros tamanhos</a></u>
            </p>
            <CustomizableProductCartItem
                :class="{ busy: loadingCart }"
                v-for="product in customizableProducts"
                :key="product.id"
                :is-cart-page="true"
                :canvas-id="product.canvas_id"
                :product="product"
                @remove="remove(product)"
                @add-one="addOne(product)"
                @remove-one="removeOne(product)"
                @quantity-change="onTypeProductQuantity(product, $event)"
            />
        </div>
    </div>
</template>

<script>
    import { lazyLoadInstance } from '../../script/common';
    import CustomizableProductCartItem from './CustomizableProductCartItem.vue';
    import { cartStore } from '../../script/store/cart-store';

    export default {
        name: 'CustomizableCartProduct',

        components: {
            CustomizableProductCartItem,
        },

        props: {
            customizableProducts: {
                type: Array,
                required: true,
            },
            isLateralMenu: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                loadingCart: false,
                productionTootlip:
                    'Este produto será produzido após a confirmação da sua compra. O prazo de entrega informado já considera o tempo de produção',
            };
        },

        mounted() {
            lazyLoadInstance.update();
        },

        watch: {
            customizableProducts: function () {
                this.$nextTick(function () {
                    lazyLoadInstance.update();
                });
            },
        },

        computed: {
            usedProduct() {
                if (this.customizableProducts && this.customizableProducts.length > 0) {
                    return this.customizableProducts[0];
                }
            },

            productName() {
                return this.usedProduct.product.name;
            },

            image() {
                if (this.usedProduct && this.usedProduct.product) {
                    return this.usedProduct.canvas.image_cdn_url;
                }
            },

            productQuantity() {
                if (this.customizableProducts && this.customizableProducts.length > 0) {
                    return this.customizableProducts.reduce(
                        (accumulator, product) => accumulator + product.quantity,
                        0
                    );
                }
            },

            productsTotalPrice() {
                if (this.usedProduct && this.productQuantity) {
                    return this.usedProduct.total_price * this.productQuantity;
                }
                return 0;
            },

            showProductionDate() {
                return (
                    this.usedProduct.production_date &&
                    this.usedProduct.product.is_active &&
                    (this.usedProduct.has_quantity || this.usedProduct.product.in_stock)
                );
            },
        },

        methods: {
            goToEdit() {
                window.location.href =
                    this.usedProduct.product.full_link + '/' + this.usedProduct.canvas.public_id;
            },

            handleCartApiError: function (response, defaultMessage) {
                try {
                    response = response.response.data;
                    let message = response.errors[0][0];

                    for (let i = 1; i < response.errors.length; i++) {
                        message += ';' + response.errors[i][0];
                        if (i === response.errors.length - 1) {
                            message += '.';
                        }
                    }

                    this.productsAlert = {
                        message: message,
                        isError: true,
                    };
                } catch (error) {
                    this.productsAlert = {
                        message: defaultMessage,
                        isError: true,
                    };
                }
            },

            addOne: function (product) {
                if (
                    product.product.type.id !== 13 ||
                    product.quantity < this.cart.maximum_allowed_packings
                ) {
                    this.updateProductQuantity(product, product.quantity + 1);
                }
            },

            removeOne: function (product) {
                this.updateProductQuantity(product, product.quantity - 1);
            },

            remove: function (product) {
                this.updateProductQuantity(product, 0);
            },

            onTypeProductQuantity: function (product, ev) {
                const typedQuantity = parseInt(ev.target.value);
                const quantity =
                    product.product.type.id === 13
                        ? Math.min(typedQuantity, this.cart.maximum_allowed_packings)
                        : typedQuantity;
                if (quantity !== product.quantity) {
                    this.updateProductQuantity(product, quantity);
                } else {
                    ev.target.value = quantity;
                }
            },

            updateProductQuantity: function (product, requestedQuantity) {
                this.$emit('changing-products');

                const diffQuantity = requestedQuantity - product.quantity;

                cartStore
                    .updateProduct({
                        products: [
                            {
                                product_id: product.produto_id,
                                variation_id: product.variation_id,
                                quantity: diffQuantity,
                                canvas_id: product.canvas_id,
                            },
                        ],
                    })
                    .then(() => {
                        if (requestedQuantity === 0) {
                            this.productsAlert = {
                                message: 'Item removido com sucesso',
                            };
                        }

                        this.$emit('update-cart');
                        this.reportCartProductToTagManager(product, diffQuantity);
                    })
                    .catch((response) => {
                        this.$emit('done-changing-products');
                        this.handleCartApiError(
                            response,
                            requestedQuantity === 0
                                ? 'Não foi possível remover o item'
                                : 'Não foi possível alterar a quantidade'
                        );
                    });
            },

            reportCartProductToTagManager: function (cartProduct, diffQuantity) {
                const reportProduct = {
                    item_name: cartProduct.product.name,
                    item_id: cartProduct.product.id + '',
                    price: cartProduct.product.price,
                    item_brand: (cartProduct.product.store || {}).name || 'Uma Penca',
                    item_category: (cartProduct.product.type || {}).name,
                    item_category2: cartProduct.gender,
                    item_category3: cartProduct.size,
                    item_category4: (cartProduct.product.color || {}).name,
                    quantity: diffQuantity,
                    currency: 'BRL',
                };

                reportProduct.variant = `${cartProduct.gender}-${cartProduct.size}-${
                    cartProduct.product_color_name || cartProduct.color_name
                }`
                    .replace('--', '-')
                    .replace(/-$/, '')
                    .replace(/^-/, '');

                this.reportItemToTagManager(reportProduct);
            },

            reportItemToTagManager: function (product) {
                const report = {
                    ecommerce: {},
                };

                window.dataLayer.push({ ecommerce: null });
                if (product.quantity > 0) {
                    report.event = 'add_to_cart';
                    report.ecommerce.items = [product];
                } else {
                    product.quantity = Math.abs(product.quantity);
                    report.event = 'remove_from_cart';
                    report.ecommerce.items = [product];
                }

                window.dataLayer.push(report);
            },
        },
    };
</script>
